import { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { styled } from '@mui/material';
import useLocales from '../../../hooks/useLocales';

const Link = styled('a')(() => ({
    color: '#FFF',
    fontWeight: 'bold'
}));

DownloadViewer.propTypes = {
    preview: PropTypes.any,
};

export default function DownloadViewer({ preview }) {

    const { translate } = useLocales();

    return (
        <div className="preview-box">
            <span className="not-available">
                {translate('preview.download')}
                <br/>
                <br/>
                { preview.files.map((item) => 
                    <Fragment key={item.label}>
                        <Link href={item.fileUrl}>{ item.label }<br/>{item.mimeType}</Link>
                        <br/><br/>
                    </Fragment>
                )}
            </span>
        </div>
    );
}